/* Foshe Currency Display
 * Replaces "Rs." with "₹" and strips the " INR" ISO suffix from prices
 * throughout the theme. Runs on load and via MutationObserver for
 * dynamically rendered content (cart updates, variant changes, quick view).
 *
 * Reason we do this in JS rather than theme settings: money_format is a
 * shop-level config and requires admin access to change globally. JS
 * transform is cheaper than re-plumbing every price filter.
 */
(function () {
  'use strict';

  var RS_PATTERN = /Rs\.\s?/g;
  var INR_PATTERN = /\s?INR\b/g;

  function transformText(value) {
    if (typeof value !== 'string') return value;
    if (!value) return value;
    if (!value.includes('Rs.') && !value.includes('INR')) return value;
    return value.replace(RS_PATTERN, '₹').replace(INR_PATTERN, '');
  }

  function walkAndReplace(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var v = n.nodeValue;
        if (!v || (!v.includes('Rs.') && !v.includes('INR'))) return NodeFilter.FILTER_REJECT;
        // Skip inside <script>, <style>, <textarea>
        var parent = n.parentNode && n.parentNode.nodeName;
        if (parent === 'SCRIPT' || parent === 'STYLE' || parent === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var node;
    var pending = [];
    while ((node = walker.nextNode())) pending.push(node);
    for (var i = 0; i < pending.length; i++) {
      var original = pending[i].nodeValue;
      var next = transformText(original);
      if (next !== original) pending[i].nodeValue = next;
    }
  }

  function boot() {
    walkAndReplace(document.body);

    // Watch for dynamically injected price text (variant swaps, cart drawer,
    // quick-add responses).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) walkAndReplace(node);
            else if (node.nodeType === 3) {
              var next3 = transformText(node.nodeValue);
              if (next3 !== node.nodeValue) node.nodeValue = next3;
            }
          });
        } else if (m.type === 'characterData') {
          var nextCD = transformText(m.target.nodeValue);
          if (nextCD !== m.target.nodeValue) m.target.nodeValue = nextCD;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
